import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from 'react-icons/bs';
import { BsArrowClockwise } from "react-icons/bs";
import { loadModules } from 'esri-loader';

const RAILWAYS_NPM_KPI = ({ data, changeValues, filter, showModalCal }) => {

    const { setValues, values, sumTotal, formatNumber, calculoPromedio, calculoAveTravel, calculoPer100km, calculoChange } = useKPIs();

    console.log("DATA: ", data);


    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        getRegionalPartnerGeo();
    }, [filter.objectid]);

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        let len = data.length;

        const datas = {
            infrastructure: {
                heavyPreiodicMainReq: {
                    req_heavy_maint: calculoPromedio('req_heavy_maint', filter.yearInit),
                    req_rehab: calculoPromedio('req_rehab', filter.yearInit)
                },
                upgradingRequirements: {
                    req_upgrade_inc_cap: calculoPromedio('req_upgrade_inc_cap', filter.yearInit),
                    req_upgrade_add_line: calculoPromedio('req_upgrade_add_line', filter.yearInit)
                },
                climateChangeResil: {
                    ch_flood_inci: calculoPer100km('ch_flood_inci', filter.yearInit),
                    ch_closure_adv_weather_cond: calculoPer100km('ch_closure_adv_weather_cond', filter.yearInit),
                    ch_embank_fail: calculoPer100km('ch_embank_fail', filter.yearInit),
                }
            },
            operations: {
                capacity_used: calculo(filter.yearInit) / len,
                ave_travel_time_pass: calculoAveTravel('ave_travel_time_pass', filter.yearInit),
                ave_travel_time_freight: calculoAveTravel('ave_travel_time_freight', filter.yearInit)
            },
            safety: {
                num_signi_accidents_change: calculoChange('num_signi_accidents', parseInt(filter.yearInit) + 1),
                accident_fatal: {
                    ser_accident_fatal: calculoChange('ser_accident_fatal', filter.yearInit),
                    signi_inj_accident_fatal_num: calculoChange('signi_inj_accident_fatal_num', filter.yearInit)
                },
                accident_fatal_change: {
                    ser_accident_fatal: calculoChange('ser_accident_fatal', parseInt(filter.yearInit) + 1),
                    signi_inj_accident_fatal_num: calculoChange('signi_inj_accident_fatal_num', parseInt(filter.yearInit) + 1)
                },
                ser_inj: {
                    ser_accident_ser_inj: formatNumber(sumTotal('ser_accident_ser_inj', filter.yearInit)),
                    signi_inj_accident_num: formatNumber(sumTotal('signi_inj_accident_num', filter.yearInit))
                },
                signi_inj_accident_levelcross: calculoChange('signi_inj_accident_levelcross', filter.yearInit),
                signi_inj_accident_levelcross_change: calculoChange('signi_inj_accident_levelcross', parseInt(filter.yearInit) + 1),
                ser_accident_levelcross: calculoChange('ser_accident_levelcross', filter.yearInit),
                levelCrossingsFatalities: "" // TODO: CONSULTAR CAMPO
            },
            maintenance: {
                maint_cost_total_kmpy: formatNumber(sumTotal('maint_cost_total_kmpy', filter.yearInit)),
                maint_cost_infra: formatNumber(sumTotal('maint_cost_infra', filter.yearInit)),
                maint_cost_sign_telecom: formatNumber(sumTotal('maint_cost_sign_telecom', filter.yearInit)),
                maint_cost_elect: formatNumber(sumTotal('maint_cost_elect', filter.yearInit))
            },
            // environmentalImpact: {
            //     globalWarmingPotential: "", // TODO: CONSULTAR CAMPO
            //     noise: "" // TODO: CONSULTAR CALCULO
            // }
        }

        changeValues(datas)
    }

    const calculo = (year) => {
        let total = 0;

        let dataFiltered = data.filter(item => item.attributes.year == year);

        dataFiltered.map(item => {
            let total = item.attributes.pass_trains ?? 0 + item.attributes.freight_trains;

            if (total != 0)
                total += (total) / item.attributes.capacity
        })

        return total;
    }

    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/22";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_rw_id =${filter.objectid}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
                setStatusTabDisabled(false);

            } else {
                console.log("No features found with the given npmRoadId");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };


    const generateFormFields = (formValues, typeForm) => {
        const excludedFields = ["objectid", "globalid", "npm_road_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={true}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                </Col>
            ));
    };

    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Heavy/Periodic Maintenance Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_heavy_maint" label="Percentage of network requiring heavy maintenance" name="infrastructure.heavyPreiodicMainReq.req_heavy_maint" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_rehab" label="Percentage of network requiring rehabilitation" name="infrastructure.heavyPreiodicMainReq.req_rehab" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Upgrading Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgradingRequirements.req_upgrade_inc_cap" label="Percentage of network requiring upgrade to increase capacity" name="infrastructure.upgradingRequirements.req_upgrade_inc_cap" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgradingRequirements.req_upgrade_add_line" label="Percentage of network requiring upgrade (additional track/new line)" name="infrastructure.upgradingRequirements.req_upgrade_add_line" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Climate Change Resilience</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_flood_inci" label="Number of flooding incidents per 100km" name="infrastructure.climateChangeResil.ch_flood_inci" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" label="Number of closures due to adverse weather conditions per 100km" name="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_embank_fail" label="Number of embankment failures per 100km" name="infrastructure.climateChangeResil.ch_embank_fail" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Operations" title="Operations" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.capacity_used" label="Capacity utilisation rate (%)" name="operations.capacity_used" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.ave_travel_time_pass" label="Average travel time (including stops) per km (passengers)" name="operations.ave_travel_time_pass" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="operations.ave_travel_time_freight" label="Average travel time (including stops) per km (freight)" name="operations.ave_travel_time_freight" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Safety" title="Safety" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="safety.num_signi_accidents_change" label="Significant accidents (% change relatively to user-defined period)" name="safety.num_signi_accidents_change" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCal('safety.num_signi_accidents_change', 'num_signi_accidents_change')}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Fatalities</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.accident_fatal.ser_accident_fatal" label="Fatalities (no. per million train km)" name="safety.accident_fatal.ser_accident_fatal" disabled={true} />
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.accident_fatal.signi_inj_accident_fatal_num" label="Fatalities (% change relatively to user-defined period)" name="safety.accident_fatal.signi_inj_accident_fatal_num" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal('safety.accident_fatal.signi_inj_accident_fatal_num', 'signi_inj_accident_fatal_num')}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Fatalities - change</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.accident_fatal_change.ser_accident_fatal" label="Fatalities (no. per million train km)" name="safety.accident_fatal_change.ser_accident_fatal" disabled={true} />
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.accident_fatal_change.signi_inj_accident_fatal_num" label="Fatalities (% change relatively to user-defined period)" name="safety.accident_fatal_change.signi_inj_accident_fatal_num" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal('safety.accident_fatal_change.signi_inj_accident_fatal_num', 'signi_inj_accident_fatal_num')}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Serious Injuries</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.ser_inj.ser_accident_ser_inj" label="Injuries (no. per million train km)" name="safety.ser_inj.ser_accident_ser_inj" disabled={true} />
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.ser_inj.signi_inj_accident_num" label="Injuries (% change relatively to user-defined period)" name="safety.ser_inj.signi_inj_accident_num" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Level crossings safety indicators</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.signi_inj_accident_levelcross" label="Level-Crossings - Significant Accidents (no. per million train km)" name="safety.signi_inj_accident_levelcross" disabled={true} />
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.signi_inj_accident_levelcross_change" label="Level-Crossings - Significant Accidents (% change relatively to user-defined period)" name="safety.signi_inj_accident_levelcross_change" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal('safety.signi_inj_accident_levelcross_change', 'signi_inj_accident_levelcross_change')}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.ser_accident_levelcross" label="Level Crossings - Serious Injuries (% change relatively to user-defined period)" name="safety.ser_accident_levelcross" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal('safety.ser_accident_levelcross', 'ser_accident_levelcross')}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.levelCrossingsFatalities" label="Level Crossings – Fatalities (% change relatively to user-defined period)" name="safety.levelCrossingsFatalities" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal('safety.levelCrossingsFatalities', 'levelCrossingsFatalities')}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Maintenance" title="Maintenance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_total_kmpy" label="Maintenance cost – Total (Euro/km)" name="maintenance.maint_cost_total_kmpy" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_infra" label="Maintenance cost – Infrastructure (Euro/km)" name="maintenance.maint_cost_infra" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_sign_telecom" label="Maintenance cost - Signalling and telecom system (Euro/km)" name="maintenance.maint_cost_sign_telecom" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_elect" label="Maintenance cost - Electrification system (Euro/km)" name="maintenance.maint_cost_elect" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Others" title="Others" className={style.tabHeight}>
                    <Container>
                        <Row>
                            {generateFormFields(attributes)}
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default RAILWAYS_NPM_KPI;